import { inject } from '@angular/core'
import { CanDeactivateFn, Router } from '@angular/router'
import { GlobalVariable } from '../services/global-variable/global-variable'

export const unsavedChangesGuard: CanDeactivateFn<any> = (component, currentRoute, currentState, nextState) => {
	const router = inject(Router)
	const globalVariableService = inject(GlobalVariable)

	if (currentRoute.queryParams['offer_id']) {
		if (
			component.activeStep === component.disqulaifiedPageNumber ||
			component.activeStep === component.confirmedPageNumber
		) {
			globalVariableService.offerId = undefined
			return true
		}

		if (
			confirm(
				'Are you sure you want to abandon this offer? These responses will be lost, and you will need to start over for a new offer.',
			)
		) {
			return true
		} else {
			router.navigateByUrl(currentState.url)
			return false
		}
	} else {
		return true
	}
}
